'use strict';
import angular from 'angular';
import xandrInvestFrequencyHtmlUrl from './views/xandrInvest.frequency.html';

var app = angular.module('app.xandrInvestFrequencyComponent', []);

app.component('xandrInvestFrequency', {
    bindings: {
        showActions: '=',
        sets: '='
    },
    templateUrl: xandrInvestFrequencyHtmlUrl,

    // The controller that handles our component logic
    controller: function() {
        let self = this;
        self.unitTypes = ['hour', 'day', 'week', 'lifetime', 'break', 'download'];

        self.addNewSet = function() {
            if (self.sets.length < 5) {
                self.sets.push({
                    impressions: null,
                    unitType: ''
                });
            }
        };

        self.clearKey = function(frequencyIndex) {
            self.sets.splice(frequencyIndex, 1);
        };

        self.initComponent = function() {
            if (self.sets && self.sets.length > 0) {
                if (typeof self.sets == 'string') {
                    self.sets = JSON.parse(self.sets);
                }
                if (self.showActions) {
                    self.showFrequencyView = false;
                    self.enableEditView = true;
                } else {
                    self.showFrequencyView = true;
                    self.enableEditView = false;
                }
            } else {
                self.sets = [{
                    impressions: null,
                    unitType: ''
                }];
                self.showFrequencyView = false;
            }
        };

        self.validateFieldValues = function() {
            for (let set of self.sets) {
                if (set.unitType === 'hour' && !(set.impressions >= 1 && set.impressions <= 24)) {
                    return 'hour: The impressions property must be between 1 and 24 (inclusive)';
                } else if (set.unitType === 'day' && !(set.impressions >= 1 && set.impressions <= 28)) {
                    return 'day: The impressions property must be between 1 and 28 (inclusive)';
                } else if (set.unitType === 'week' && !(set.impressions >= 1 && set.impressions <= 4)) {
                    return 'week: The impressions property must be between 1 and 4 (inclusive)';
                } else if ((set.unitType === 'lifetime' || set.unitType === 'break' || set.unitType === 'download') && set.impressions !== 1) {
                    return 'For lifetime, break, or download, impressions must be set to 1';
                }
            }
        };

        self.initComponent();
    }
});